import { render, staticRenderFns } from "./ResponseMessageChart.vue?vue&type=template&id=2a775686&scoped=true&"
import script from "./ResponseMessageChart.vue?vue&type=script&lang=js&"
export * from "./ResponseMessageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a775686",
  null
  
)

export default component.exports